import { render, staticRenderFns } from "./Unoapi.vue?vue&type=template&id=33366f52&"
import script from "./Unoapi.vue?vue&type=script&lang=js&"
export * from "./Unoapi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports